<template>
  <b-modal id="modal-filter" centered hide-footer title="Filters" size="lg">
    <div class="row">
      <div v-if="showStatusFilter" class="col-md-6 mb-3">
        <label class="form-label">Status</label>
        <v-select
          v-model="filters.status"
          :options="statusOptions"
          :reduce="(option) => option.value"
          label="label"
          placeholder="Choose Status"
        >
        </v-select>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Approval</label>
        <v-select
          v-model="filters.approval_step"
          :options="approvalStepOptions"
          :reduce="(option) => option.value"
          label="label"
          placeholder="Choose Approval"
        >
        </v-select>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Course Type</label>
        <v-select
          v-model="filters.training_category"
          :options="trainingCategoryOptions"
          :reduce="(option) => option.value"
          label="label"
          placeholder="Choose Course Type"
        >
        </v-select>
      </div>

      <div v-if="learningType === 'structured_learning'" class="col-md-6 mb-3">
        <label class="form-label">Training Scope</label>
        <v-select
          v-model="filters.training_scope"
          :options="trainingScopeOptions"
          :reduce="(option) => option.value"
          label="label"
          placeholder="Choose Training Scope"
        >
        </v-select>
      </div>

      <!-- Platform -->
      <div v-if="learningType === 'structured_learning'" class="col-md-6 mb-3">
        <label class="form-label">Platform</label>
        <v-select
          v-model="filters.platform"
          :options="platformOptions"
          :reduce="(option) => option.value"
          label="label"
          placeholder="Choose Platform"
        >
        </v-select>
      </div>

      <!-- Training Method -->
      <div v-if="learningType === 'social_learning'" class="col-md-6 mb-3">
        <label class="form-label">Coaching Type</label>
        <v-select
          v-model="filters.coaching_type_id"
          :options="coachingTypeOptions"
          :reduce="(option) => option.value"
          label="label"
          placeholder="Choose Coaching Type"
        >
        </v-select>
      </div>

      <!-- Training Method (temporary disabled)-->
      <!-- <div v-if="learningType === 'structured_learning'" class="col-md-6 mb-3">
        <label class="form-label">Training Method</label>
        <v-select
          v-model="filters.training_method_id"
          :options="trainingMethodOptions"
          :reduce="(option) => option.value"
          label="label"
          placeholder="Choose Training Method"
        >
        </v-select>
      </div> -->

      <!-- Training Type -->
      <div v-if="learningType === 'structured_learning'" class="col-md-6 mb-3">
        <label class="form-label">Training Type</label>
        <v-select
          v-model="filters.training_type"
          :options="trainingTypeOptions"
          :reduce="(option) => option.value"
          label="label"
          placeholder="Choose Training Type"
        >
        </v-select>
      </div>

      <!-- Competency -->
      <div class="col-md-6 mb-3">
        <label class="form-label">Competency</label>
        <v-select
          v-model="filters.competency_id"
          :options="competencyOptions"
          :reduce="(option) => option.value"
          label="label"
          placeholder="Choose Competency"
        >
        </v-select>
      </div>
    </div>

    <!-- Modal Footer with Buttons -->
    <div class="d-flex justify-content-end gap-3 mt-4">
      <button type="button" class="btn btn-outline-danger" @click="resetFilters">Reset filters</button>
      <button type="button" class="btn btn-danger" @click="applyFilters">Apply filters</button>
    </div>
  </b-modal>
</template>

<script>
import { cleanObject } from "../utils/utils";

export default {
  name: "ModalFilter",

  props: {
    modalId: { type: String, default: "modal-filter" },
    competencyOptions: { type: Array, default: () => [] },
    trainingTypeOptions: { type: Array, default: () => [] },
    trainingMethodOptions: { type: Array, default: () => [] },
    value: {
      type: Object,
      default: () => ({}),
    },
    showStatusFilter: { type: Boolean, default: false },
    learningType: { type: String, default: "structured_learning" },
  },

  watch: {
    value: {
      deep: true,
      handler(val) {
        this.filters = { ...val };
      },
    },
  },

  data() {
    return {
      trainingScopeOptions: [
        { value: "BIB-HO", label: "BIB-HO" },
        { value: "BIB-Site", label: "BIB-Site" },
        { value: "BIB-Partner", label: "BIB-Partner" },
      ],
      platformOptions: [
        { value: "My Learning", label: "My Learning" },
        { value: "Ugems University", label: "BIB Academy" },
        { value: "Other", label: "Other" },
      ],
      coachingTypeOptions: [
        { value: "C", label: "Coaching" },
        { value: "M", label: "Mentoring" },
      ],
      trainingCategoryOptions: [
        { value: "mandatory", label: "Mandatory" },
        { value: "development", label: "Development" },
      ],
      approvalStepOptions: [
        { value: "manager", label: "Manager" },
        { value: "hse", label: "HSE Training" },
        { value: "hr", label: "HR Operation Site" },
      ],
      statusOptions: [
        { value: "open", label: "Open" },
        { value: "enrolled", label: "Enrolled" },
        { value: "submitted", label: "Submitted" },
        { value: "approved", label: "Approved" },
        { value: "rejected", label: "Rejected" },
        { value: "completed", label: "Completed" },
        { value: "canceled", label: "Cancelled" },
      ],
      filters: {
        status: null,
        approval_step: null,
        training_scope: null,
        training_category: null,
        platform: null,
        training_method_id: null,
        training_type: null,
        competency_id: null,
        coaching_type_id: null,
      },
    };
  },
  computed: {},
  mounted() {},
  methods: {
    resetFilters() {
      this.filters = {
        status: null,
        approval_step: null,
        training_scope: null,
        training_category: null,
        platform: null,
        training_method_id: null,
        training_type: null,
        competency_id: null,
        coaching_type_id: null,
      };
      this.$emit("reset-filters");
    },

    applyFilters() {
      const payload = cleanObject({
        ...this.filters,
        status: this.showStatusFilter ? this.filters.status : null,
      });
      this.$emit("apply-filters", payload);
    },
  },
};
</script>

<style scoped></style>
